import { createReducer } from '@reduxjs/toolkit'

import { InternalConfirmActions } from './actions'
import type { ConfirmationState } from './types'

export const confirmationReducer = createReducer<ConfirmationState | null>(
  null,
  (builder) =>
    builder
      .addCase(InternalConfirmActions.set, (_, { payload }) => payload)
      .addCase(InternalConfirmActions.clear, () => null)
)
